/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemTextInputFormat } from './formPagePropertyItemTextInputFormat';
import { FormPagePropertyItemReEnterSetting } from './formPagePropertyItemReEnterSetting';
import { FormPagePropertyItemTextAllOfCharacterTypeAllowed } from './formPagePropertyItemTextAllOfCharacterTypeAllowed';
import { FormPagePropertyItemTextErrorMessage } from './formPagePropertyItemTextErrorMessage';
import { FormPagePropertyItemStringConvertRule } from './formPagePropertyItemStringConvertRule';


/**
 * 文字型の入力項目を表す。 文字型の注意点としては、以下の点。 1) 以下の入力形式の場合の形式チェック、文字数チェックは以下の通り。 姓名型:  　姓名いずれかに入力が無ければエラー扱い。(入力形式エラー)  　全角スペース込みで4000文字を超える場合はエラー。（固定で4000文字以下でご入力ください） 電話番号:  　3つの枠すべて入力しなければエラー扱い。(入力形式エラー) 　ハイフン込みで4000文字を超える場合はエラー。（固定で4000文字以下でご入力ください） 郵便番号:  　前3文字、後4文字以外はエラー扱い。(入力形式エラー) 郵便番号ハイフンなし: 　7文字以外はエラー扱い。(入力形式エラー) 2) 「スペースを許可しない」制限は、classicとは違い単独で動作する。（classicではその他の任意の文字種制限を設定しないと無視される） 
 */
export interface FormPagePropertyItemText { 
    /**
    * フォーム入力項目大種別
    */
    propertyType: 'text';
    /**
    * 入力項目ID
    */
    propertyId: string;
    /**
    * 項目名(管理機能のopenapiではdisplay_name）
    */
    name: string;
    /**
    * 項目のコメント(管理機能のopenapiではdisplay_comment）
    */
    comment?: string;
    /**
    * 注意書き・凡例(管理機能のopenapiではcaution）
    */
    note?: string;
    /**
    * 必須/任意のラベルを表示するかどうか.
    */
    displayRequiredLabel: boolean;
    stringConvertRule?: FormPagePropertyItemStringConvertRule;
    type: FormPagePropertyItemText.TypeEnum;
    /**
    * 入力可能な最大文字数。超えた場合はバリデーションエラー 郵便番号形式の場合は含めない 
    */
    maxLength?: number;
    /**
    * 入力可能な最大文字数(管理画面で設定された文字数。入力可能文字数としてコンシューマ側で表示する用途) 
    */
    maxLengthOrigin?: number;
    /**
    * 入力可能な最小文字数。超えた場合はバリデーションエラー 郵便番号形式の場合は含めない 
    */
    minLength?: number;
    /**
    * 入力可能な最小文字数(管理画面で設定された文字数。入力可能文字数としてコンシューマ側で表示する用途) 
    */
    minLengthOrigin?: number;
    /**
    * 入力可能な文字種を正規表現として表現。後続の使用できる文字種、スペース入力を許可するかどうかで決まる。 なお、「スペースを許可しない」制限は、その他の任意の文字種制限を設定しないと無視される。 また、入力形式によっても変える想定。姓名型だと間に全角スペース、電話番号、郵便番号だと間にハイフンが入る 
    */
    pattern?: string;
    reEnter?: FormPagePropertyItemReEnterSetting;
    /**
    * 伏字にするか
    */
    password?: boolean;
    characterTypeAllowed?: FormPagePropertyItemTextAllOfCharacterTypeAllowed;
    inputFormat: FormPagePropertyItemTextInputFormat;
    errorMessage?: FormPagePropertyItemTextErrorMessage;
}

export namespace FormPagePropertyItemText {
    export type TypeEnum = 'string';
    export const TypeEnum = {
        String: 'string' as TypeEnum
    };
}


